import { Alignment } from '@/components/Table/types';
import { ClassNameValue } from 'tailwind-merge';

export const alignStyles: Partial<Record<Alignment, ClassNameValue>> = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};
